import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@mantine/core";
import { signIn } from "@/utils/auth";

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignIn = async () => {
    try {
      await signIn();
      const params = new URLSearchParams(location.search);
      const after = params.get("after");
      if (after) {
        navigate(decodeURIComponent(after));
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Sign in failed:", error);
    }
  };

  return (
    <div className="flex flex-col h-screen items-center justify-start gap-5">
      <div className="h-1/5"></div>
      <h1 className="text-2xl font-bold text-gray-900">Out of Stock Review</h1>
      <Button onClick={handleSignIn} variant="primary" size="lg">
        Sign In with Google
      </Button>
    </div>
  );
};
